/**
 * The empty workspace behind frames, on every surface: the canvas pane, the
 * focus backdrop, and the wall's space between cards
 * (`WORKSPACE_PANE_ATTR`). A press there means "away from any frame".
 */
export const WORKSPACE_PANE_ATTR = "data-workspace-pane";

const WORKSPACE_PANES = `.react-flow__pane, .denker-focus-backdrop, [${WORKSPACE_PANE_ATTR}="true"]`;

/** Whether `target` itself is empty workspace (not a frame or a control). */
export function isWorkspacePaneTarget(target: EventTarget | null): boolean {
  return target instanceof Element && target.matches(WORKSPACE_PANES);
}
